import formatGroupedValues from "../utils/formatGroupedValues";
import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";
import React from "react";
import FilterField from "../fields/FilterField";
import FilterMultiSelect from "../fields/FilterMultiSelect";
import FilterSelect from "../fields/FilterSelect";

export const TEMP_STAFF_FORMS_SORT_OPTIONS = [
  { value: "name", label: "Form" },
  { value: "state", label: "State" },
  { value: "submit_date", label: "Submitted Date" },
];

export const TEMP_STAFF_FORMS_DEFAULT_FILTERS = {
  stateFilters: [],
  sortBy: "name",
  sortDirection: "asc",
};

export function buildTempStaffFormsFilterChips({
  stateFilters = [],
  stateOptions = [],
}) {
  const chips = [];
  if (stateFilters.length > 0) {
    const labelFor = (value) =>
      stateOptions.find((o) => o.value === value)?.label || value;
    chips.push({
      id: "states",
      key: "stateFilters",
      fieldId: "temp-staff-forms-state",
      label: `State: ${formatGroupedValues(stateFilters, labelFor, 3)}`,
    });
  }
  return chips;
}

function FieldWrapper({ fieldId, label, focusedFieldId, onFocusClear, children }) {
  return (
    <FilterField
      id={fieldId}
      label={label}
      focusedFieldId={focusedFieldId}
      onFocusClear={onFocusClear}
    >
      {children}
    </FilterField>
  );
}

export default function TempStaffFormsFilterFields({
  focusedFieldId,
  onFocusClear,
  stateOptions = [],
  stateFilters = [],
  setStateFilters,
  sortBy = "name",
  setSortBy,
  sortDirection = "asc",
  setSortDirection,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="temp-staff-forms-state"
        label="State"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="temp-staff-forms-state"
          options={stateOptions}
          value={stateFilters}
          onChange={setStateFilters}
          placeholder="Select…"
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="temp-staff-forms-sort-by"
        label="Sort By"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="temp-staff-forms-sort-by"
          value={sortBy}
          onChange={setSortBy}
          options={TEMP_STAFF_FORMS_SORT_OPTIONS}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="temp-staff-forms-sort-direction"
        label="Sort Direction"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="temp-staff-forms-sort-direction"
          value={sortDirection}
          onChange={setSortDirection}
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
          placeholder={null}
        />
      </FieldWrapper>
    </>
  );
}
